import { useGameStore } from '../stores/game.js';
import { formatMultiplier } from '../utils/format.js';
import styles from './MultiplierBadge.module.css';

export function MultiplierBadge(): JSX.Element | null {
  const total = useGameStore((s) => s.multiplier.total);
  if (total <= 1.001) {
    return null;
  }
  return (
    <div className={styles.root} aria-label={`Множитель ${formatMultiplier(total)}`}>
      <span className={styles.value}>{formatMultiplier(total)}</span>
    </div>
  );
}
